export * from './utilities'
import * as pinia from 'pinia'
import { AppletOptions } from '@artup/client'
import pkg from '../package.json'
import components from './components'
import routes from './routes'
import { useAccountsStore } from './store'

export * from './components'
export * from './store'

/**
 * Returns Accounts applet definition
 * @returns {AppletOptions}
 */
export function useAccountsApplet () {
  if (pinia) {
    const { name, version, description } = pkg
    const store = useAccountsStore()

    return new AppletOptions({
      id: 'accounts',
      name,
      version,
      description,
      components,
      routes,
      store
    })
  }
}
